<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <template v-if="Object.keys(filtered_labExam).length > 0">
                            <tr v-for="(row, index) in filtered_labExam" :key="index">
                                <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                                <td>{{row}}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="2">No records found.</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      labExam: {
        type: Object
      }
    },
    mixins: [TableDataExcluder],
    data() {
      return {
        excludeFields: ['id']
      }
    },
    computed: {
      filtered_labExam() {
        return this.excluder(this.labExam, this.excludeFields);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/Tabs/LabExamTab.vue